import React from 'react';
import { Modal, Table, Button } from 'antd';
import './index.css';

const FIELD_HISTORY_COLUMNS = [
  {
    title: 'Change Source',
    dataIndex: 'changeSource',
    key: 'changeSource',
    render: (text) => text || 'N/A'
  },
  {
    title: 'Update Time',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    render: (text) => text || 'N/A'
  },
  {
    title: 'Old Value',
    dataIndex: 'oldValue',
    key: 'oldValue',
    render: (text) => text || 'N/A'
  },
  {
    title: 'New Value',
    dataIndex: 'newValue',
    key: 'newValue',
    render: (text) => text || 'N/A'
  }
];

const FieldHistoryModal = ({
  open,
  onCancel,
  title,
  data,
}) => (
  <Modal
    title={title}
    open={open}
    onCancel={onCancel}
    footer={[
      <Button key="close" onClick={onCancel}>
        Close
      </Button>
    ]}
    width={800}
  >
    {data && Array.isArray(data) && data.length > 0 ? (
      <Table
        dataSource={data.map((item, index) => ({ ...item, key: index }))}
        columns={FIELD_HISTORY_COLUMNS}
        pagination={false}
        size="small"
      />
    ) : (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <p>No field descriptions available</p>
      </div>
    )}
  </Modal>
);

export default FieldHistoryModal;
